<template>
    <div>
        <CModal
                :title="message.title"
                :color="message.color"
                :show.sync="message.status"
                :centered="true"
                :close-on-backdrop="false"
        >
          <template #header-wrapper>
            <div class="mb-5"></div>
          </template>
          <template #body-wrapper >

            <CRow>
              <CCol>
                <CButton color="secondary" class="w-100" shape="pill" >Cancel</CButton>
              </CCol>
              <CCol>
                <CButton color="danger" class="w-100 zoom" shape="pill" >Submit</CButton>
              </CCol>
            </CRow>
          </template>

          <template #footer-wrapper>
            <div >

            </div>
          </template>
        </CModal>
    </div>
</template>

<script>

    import {mapGetters} from 'vuex'

    export default {
        name: 'CenterDialogs',
        data: function () {
            return {
                // errModal: false,
                // dialog: {
                //   title: "",
                //   color: "danger",
                //   message: "",
                //   Status: false
                // }
            }
        },
        mounted() {

        },

        created() {
        },

        beforeDestroy() {

        },

        methods: {},

        computed: {
            ...mapGetters({
                message: 'dialog/dialog'
            })
        },

        watch: {
        }
    }
</script>
